import{a as i}from"./ninox-components-SKM2R3JB.js";import{a as t}from"./ninox-components-3BPDSF2O.js";function r(e){return i(e)&&"label"in e}t(r,"isLabelDescription");export{r as a};
//# sourceMappingURL=ninox-components-H6GS5QVK.js.map